import React, { useState, forwardRef, useImperativeHandle, useEffect } from "react";
import { Link } from "react-router-dom";
import { Offcanvas } from "react-bootstrap";
import DatePicker from "react-datepicker";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import { updateCandidates } from "../../../store/actions/Candidates/candidateActions";

const EditCandidate = forwardRef((props, ref) => {
  const dispatch = useDispatch();

  // Initialize form data with props (existing candidate details)
  const [formData, setFormData] = useState({
    title: props.candidate?.title || "",
    firstName: props.candidate?.firstName || "",
    lastName: props.candidate?.lastName || "",
    knownAs: props.candidate?.knownAs || "",
    home: props.candidate?.home || "",
    addressLine1: props.candidate?.address?.[0]?.addressLine1 || "",
    addressLine2: props.candidate?.address?.[0]?.addressLine2 || "",
    town: props.candidate?.address?.[0]?.town || "",
    county: props.candidate?.address?.[0]?.county || "",
    country: props.candidate?.address?.[0]?.country || "",
    postCode: props.candidate?.address?.[0]?.postcode || "",
    region: props.candidate?.address?.[0]?.region || "",
    phone: props.candidate?.phone || "",
    phoneNumber: props.candidate?.phoneNumber || "",
    email: props.candidate?.email || "",
    office: props.candidate?.office || "",
    sector: props.candidate?.sector || "",
    personId: props.candidate?.personId || "",
    consultant: props.candidate?.consultant || "",
    regDate: props.candidate?.regDate ? new Date(props.candidate.regDate) : null,
    source: props.candidate?.source || "",
    recordUpdated: props.candidate?.recordUpdated
      ? new Date(props.candidate.recordUpdated)
      : null,
    statusDate: props.candidate?.statusDate
      ? new Date(props.candidate.statusDate)
      : null,
    status: props.candidate?.status || "LIVE",
  });
  useEffect(() => {
    setFormData({
      title: props.candidate?.title || "",
      firstName: props.candidate?.firstName || "",
      lastName: props.candidate?.lastName || "",
      knownAs: props.candidate?.knownAs || "",
      home: props.candidate?.home || "",
      addressLine1: props.candidate?.address?.[0]?.addressLine1 || "",
      addressLine2: props.candidate?.address?.[0]?.addressLine2 || "",
      town: props.candidate?.address?.[0]?.town || "",
      county: props.candidate?.address?.[0]?.county || "",
      country: props.candidate?.address?.[0]?.country || "",
      postCode: props.candidate?.address?.[0]?.postcode || "",
      region: props.candidate?.address?.[0]?.region || "",
      phone: props.candidate?.contact?.phoneType || "",
      phoneNumber: props.candidate?.contact?.phoneNumber || "",
      email: props.candidate?.email || "",
      office: props.candidate?.office || "",
      sector: props.candidate?.sector || "",
      personId: props.candidate?.personId || "",
      consultant: props.candidate?.consultant || "",
      regDate: props.candidate?.regDate ? new Date(props.candidate.regDate) : null,
      source: props.candidate?.source || "",
      recordUpdated: props.candidate?.recordUpdated
        ? new Date(props.candidate.recordUpdated)
        : null,
      statusDate: props.candidate?.statusDate
        ? new Date(props.candidate.statusDate)
        : null,
      status: props.candidate?.status || "LIVE",
    })
  }, [props.candidate])

  const [errors, setErrors] = useState({});
  const [editEmploye, setEditEmploye] = useState(false);

  useImperativeHandle(ref, () => ({
    showEmployeModal() {
      setEditEmploye(true);
    },
  }));

  const validate = () => {
    const newErrors = {};
    const requiredFields = [
      "title",
      "firstName",
      "lastName",
      "postCode",
      "town",
      "country",
      "email",
      "phone",
      "phoneNumber",
    ];

    requiredFields.forEach((field) => {
      if (!formData[field].trim()) {
        newErrors[field] = `${field.replace(/([A-Z])/g, " $1")} is required.`;
      }
    });

    if (formData.email && !/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = "Email must be valid.";
    }

    if (
      formData.phoneNumber && 
      !/^(?:\+44|0)\d{10}$/.test(formData.phoneNumber)
    ) {
      newErrors.phoneNumber = "Phone Number must be a valid UK mobile number.";
    }

    setErrors(newErrors);
    if (Object.keys(newErrors).length > 0) {
      toast.error("Please fill all the required fields.");
    }
    return Object.keys(newErrors).length === 0;
  };

  const handleInputChange = (field, value) => {
    setFormData({ ...formData, [field]: value });
    setErrors({ ...errors, [field]: "" });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validate()) {
      const payload = {
        title: formData?.title,
        firstName: formData?.firstName,
        lastName: formData?.lastName,
        knownAs: formData?.knownAs,
        address: [
          {
            addressType: "HOME",
            isDefault: true,
            addressLine1: formData?.addressLine1,
            addressLine2: formData?.addressLine2,
            town: formData?.town,
            county: formData?.county,
            country: formData?.country,
            postcode: formData?.postCode,
            region: formData?.region,
          },
        ],
        contact: {
          phoneType: formData?.phone,
          phoneNumber: formData?.phoneNumber,
        },
        email: formData?.email,
        website: "",
        business: "Rapid Resourcing Ltd",
        office: "Liverpool",
        sector: formData?.sector,
        personId: formData?.personId,
        consultant: formData?.consultant,
        regDate: formData?.regDate,
        source: formData?.source,
        statusDate: formData?.statusDate,
        status: formData?.status,
      };
      dispatch(updateCandidates(payload, setEditEmploye, props.candidate?._id, props.token));
    }
  };

  return (
    <Offcanvas
      show={editEmploye}
      onHide={() => setEditEmploye(false)}
      className="offcanvas-end customeoff"
      placement="end"
    >
      <div className="offcanvas-header">
        <h5 className="modal-title">{props.Title || "Edit Candidate"}</h5>
        <button
          type="button"
          className="btn-close"
          onClick={() => setEditEmploye(false)}
        >
          <i className="fa-solid fa-xmark"></i>
        </button>
      </div>
      <div className="offcanvas-body">
        <form onSubmit={handleSubmit}>
        <div className="row">
                {[
                  { label: "Title", field: "title", required: true },
                  { label: "First Name", field: "firstName", required: true },
                  { label: "Last Name", field: "lastName", required: true },
                  { label: "Known As", field: "knownAs", required: false },
                  { label: "Home", field: "home", required: false },
                  {
                    label: "Address Line 1",
                    field: "addressLine1",
                    required: false,
                  },
                  { label: "Address Line 2", field: "addressLine2" },
                  { label: "Town", field: "town", required: true },
                  { label: "County", field: "county", required: false },
                  { label: "Country", field: "country", required: true },
                  { label: "Post Code", field: "postCode", required: true },
                  { label: "Region", field: "region", required: false },
                  {
                    label: "Phone Type",
                    field: "phone",
                    type: "select",
                    options: ["", "Home", "Mobile"],
                    required: true,
                  },
                  {
                    label: "Phone Number",
                    field: "phoneNumber",
                    type: "number",
                    required: true,
                  },
                  {
                    label: "Email",
                    field: "email",
                    type: "email",
                    required: true,
                  },
                  { label: "Office", field: "office", required: false },
                  //{ label: "Sector", field: "sector", required: false },
                  { label: "Person ID", field: "personId", required: false },
                  { label: "Source", field: "source", required: false },
                ].map(
                  ({
                    label,
                    field,
                    type = "text",
                    required = false,
                    options = [],
                  }) => (
                    <div className="col-xl-6 mb-3" key={field}>
                      {type === "select" ? (
                        <>
                          <label className="form-label">
                            {label}{" "}
                            {required && <span className="text-danger">*</span>}
                          </label>
                          <select
                            className="form-control"
                            value={formData[field]}
                            onChange={(e) =>
                              handleInputChange(field, e.target.value)
                            }
                          >
                            {options?.map((itm) => (
                              <option value={itm}>{itm}</option>
                            ))}
                          </select>
                        </>
                      ) : (
                        <>
                          <label className="form-label">
                            {label}{" "}
                            {required && <span className="text-danger">*</span>}
                          </label>
                          <input
                            type={type}
                            className="form-control"
                            value={formData[field]}
                            onChange={(e) =>
                              handleInputChange(field, e.target.value)
                            }
                          />
                        </>
                      )}

                      {errors[field] && (
                        <small className="text-danger">{errors[field]}</small>
                      )}
                    </div>
                  )
                )}
                <div className="col-xl-6 mb-3">
                  <label className="form-label">Registration Date</label>
                  <DatePicker
                    className="form-control"
                    selected={formData.regDate}
                    onChange={(date) => handleInputChange("regDate", date)}
                  />
                  {errors.regDate && (
                    <small className="text-danger">{errors.regDate}</small>
                  )}
                </div>
                <div className="col-xl-6 mb-3">
                  <label className="form-label">Record Updated</label>
                  <DatePicker
                    className="form-control"
                    selected={formData.recordUpdated}
                    onChange={(date) =>
                      handleInputChange("recordUpdated", date)
                    }
                  />
                  {errors.recordUpdated && (
                    <small className="text-danger">
                      {errors.recordUpdated}
                    </small>
                  )}
                </div>
                <div className="col-xl-6 mb-3">
                  <label className="form-label">Status Date</label>
                  <DatePicker
                    className="form-control"
                    selected={formData.statusDate}
                    onChange={(date) => handleInputChange("statusDate", date)}
                  />
                  {errors.statusDate && (
                    <small className="text-danger">{errors.statusDate}</small>
                  )}
                </div>
                <div className="col-xl-6 mb-3">
                  <label className="form-label">Status</label>
                  <select
                    className="default-select form-control"
                    value={formData.status}
                    onChange={(e) =>
                      handleInputChange("status", e.target.value)
                    }
                  >
                    <option value="PRE-REG" selected>
                      PRE-REG
                    </option>
                    <option value="LIVE">LIVE</option>
                    <option value="ARCHIVED">ARCHIVED</option>
                  </select>
                </div>
              </div>
          <div>
            <button type="submit" className="btn btn-primary me-1">
              Update
            </button>
            <Link
              to={"#"}
              onClick={() => setEditEmploye(false)}
              className="btn btn-danger light ms-1"
            >
              Cancel
            </Link>
          </div>
        </form>
      </div>
    </Offcanvas>
  );
});

export default EditCandidate;
